// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1YSGM","label":"Labeled_label__1U4DA","divider":"Labeled_divider__38uM4"};